enum TypeCustomer {
  PF = 'PF',
  PJ = 'PJ'
}

export default TypeCustomer;
